import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';

export const useDynamicImage = ({ prize }) => {
  const imgRef = useRef();

  const arrayPrize = Object.entries(prize ?? {});

  const isNecessaryCondition = (key, value) => {
    return key.startsWith('shopItem') && typeof value?.preview_image === 'string';
  };

  const [activeImage, setActiveImage] = useState(() => {
    const [, { preview_image } = {}] = arrayPrize.find(([key, value]) => isNecessaryCondition(key, value)) ?? [];
    return preview_image ?? prize?.image;
  });

  useEffect(() => {
    const shopItemsImages = arrayPrize.reduce((acc, [key, value]) => {
      if (isNecessaryCondition(key, value)) acc.push(value?.preview_image);
      return acc;
    }, []);

    if (shopItemsImages.length <= 1) return;

    let repeatCount = 1;

    const hideTimeline = gsap.timeline({
      repeat: -1,
      onRepeat() {
        repeatCount++;
      },
    });

    const { current: imgDomElement } = imgRef;

    hideTimeline
      .to(imgDomElement, {
        opacity: 0,
        duration: 0.3,
        delay: 2,
        ease: 'sine.inOut',
        onComplete: () => {
          setActiveImage(shopItemsImages[repeatCount % shopItemsImages.length]);
        },
      })
      .to(imgDomElement, { opacity: 1, duration: 0.3, ease: 'sine.inOut' });

    return () => hideTimeline.kill();
  }, [prize]);

  return { activeImage, imgRef };
};
